export default __webpack_public_path__ + "banner_m5fe1b0.png";